import { Link } from "react-router-dom";
import { Badge, Form } from "react-bootstrap";
import { EyeIcon } from "../../../components/Icons";
import { IconButton, Tooltip } from "@mui/material";

export const tableData = (
  data,
  location,
  actasAsignar,
  setActasAsignar,
  notificador,
  getActaDetalle,
  actasDetalle,
  setActaDetalle,
  handlerModal
) => {
  const columns = [
    // {
    //   field: "asignar",
    //   headerName: "Asignar",
    //   minWidth: 5,
    //   renderCell: (params) => {
    //     return (
    //       <>
    //         <div className="">
    //           <Form>
    //             <Form.Check
    //               disabled={notificador ? false : true}
    //               onChange={(e) => {
    //                 if (e.target.checked) {
    //                   setActasAsignar((prevState) => [...prevState, params.row.id]);
    //                 } else {
    //                   setActasAsignar(actasAsignar.filter((acta) => acta != params.row.id));
    //                 }
    //               }}
    //             />
    //           </Form>
    //         </div>
    //       </>
    //     );
    //   },
    // },
    { field: "id", headerName: "ID", hide: true },
    {
      field: "fecha_hora",
      headerName: "Fecha Hora",
      minWidth: 150,
      flex:2
    },
    {
      field: "numero_acta",
      headerName: "Acta",
      minWidth: 60,
      flex:2
    },
    {
      field: "infraccion",
      headerName: "Infraccion",
      minWidth: 150,
      flex:2
    },
    {
      field: "plate",
      headerName: "Patente",
      minWidth: 90,
      flex:2
    },
    {
      field: "localidad",
      headerName: "Localidad",
      minWidth: 170,
      flex:2
    },
    {
      field: "documento",
      headerName: "Documento",
      minWidth: 100,
      flex:2
    },
    // {
    //   field: "notificador_nombre",
    //   headerName: "Notificador",
    //   minWidth: 300,
    //   flex:2,
    //  renderCell:(params)=>{
    //     return (
    //       <>
    //       <span className={`${!params.row.notificador_nombre && 'text-danger'}`}>{params.row.notificador_nombre ?? "No tiene notificador"}</span>
    //       </>
    //     )
    //   }
    // },

    // {
    //   field: "estado",
    //   headerName: "Estado",
    //   minWidth: 130,

    //   renderCell:(params)=>{
    //     return (
    //       <>
    //       <Badge bg={`${params.row.estado_id == 1 ? 'primary' : params.row.estado_id == 3 ? 'warning' : 'success' }`} className={`${params.row.estado_id == 3 && 'text-dark'}`}>{params.row.estado.toLowerCase()}</Badge>
    //       </>
    //     )
    //   }
    // },

    {
      field: "actions",
      headerName: "Acciones",
      minWidth: 100,
      flex:2,
      renderCell: (params) => {
        return (
          <>
            <div className="">
              <Tooltip title="Ver detalle" arrow>
                <IconButton
                  onClick={() => {
                    const actaDetalle = actasDetalle.find((acta) => acta?.acta.id == params.row.id);
                    if (actaDetalle) {
                      setActaDetalle(actaDetalle);
                      handlerModal({ modal: true, modalName: "acta_detalle" });
                    } else {
                      getActaDetalle(params.row.id);
                    }
                  }}
                >
                  <EyeIcon />
                </IconButton>
              </Tooltip>
              {/* <Link to={`${location.pathname}/${params.row.id}`} style={{ textDecoration: "none" }}>
                <EyeIcon /> Ver detalle
              </Link> */}
            </div>
          </>
        );
      },
    },
  ];

  const rows = data.map((d, index) => {    
    return {
      id: d.id,
      fecha_hora: d.fecha_hora,
      numero_acta: d.numero_acta,
      infraccion: d.tipo,
      plate: d.plate,
      localidad: d.localidad,
      documento: d.documento_titular,
      estado: d?.estado?.descripcion,
      estado_id: d.estado_id,
      // notificador_nombre: d.notificadores[0]?.persona?.nombre,
      // fecha_notificacion: d.fecha_notificacion,
      // numero_acta: d.dependencia + "-" + d.numero_acta,
    };
  });

  const filter = (d, value) => {
    value = value.toLowerCase();

    return (
      String(d.id)?.toString().toLowerCase().includes(value) ||
      String(d.plate)?.toString().toLowerCase().includes(value) ||
      String(d.fecha_hora)?.toString().toLowerCase().includes(value) ||
      String(d.infraccion)?.toString().toLowerCase().includes(value) ||
      String(d.documento)?.toString().toLowerCase().includes(value) ||
      String(d.localidad)?.toString().toLowerCase().includes(value) ||
      String(d.numero_acta)?.toString().toLowerCase().includes(value)
    );
  };

  return { columns, rows, filter };
};
